module.exports = {
	"config": {
		"linkPrefix": "/doxity-playground",
		"name": "truffle-init-webpack",
		"license": "MIT",
		"version": "0.0.1",
		"description": "Frontend example using truffle v3",
		"author": "OttoDevs",
		"buildTime": "2017-07-17T11:56:27.859Z",
		"target": "scripts/doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"source": "https://github.com/DigixGlobal/doxity-gatsby-starter-project/archive/a4886b7a7a04c018ac04fed3125d7d4785e74bed.tar.gz",
		"out": "docs",
		"interaction": {}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ConvertLib.json",
				"ext": "json",
				"name": "ConvertLib",
				"extname": ".json",
				"basename": "ConvertLib.json",
				"dirname": "docs",
				"stem": "ConvertLib",
				"path": "docs/ConvertLib.json",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/docs/ConvertLib.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ConvertLib.json",
			"path": "/docs/ConvertLib/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "MetaCoin.json",
				"ext": "json",
				"name": "MetaCoin",
				"extname": ".json",
				"basename": "MetaCoin.json",
				"dirname": "docs",
				"stem": "MetaCoin",
				"path": "docs/MetaCoin.json",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/docs/MetaCoin.json",
				"isAbsolute": false
			},
			"requirePath": "docs/MetaCoin.json",
			"path": "/docs/MetaCoin/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/ottodev/projects/2gether/gitlab/eurotoken/ooo/scripts/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 386
// module chunks = 0